import MCard from './card/MCard.vue'
import MCardTitle from './card/MCardTitle.vue'

const Components = {
	MCard,
	MCardTitle
}

export default Components
